export const VISUALIZER_MASK_RADIUS_SIZE_FACTOR = 0.4;
export const VISUALIZER_HEXAGON_GRADIENT_START = 'rgba(255,255,255,0.8)';
export const VISUALIZER_HEXAGON_GRADIENT_END = 'rgba(255,255,255,0.2)';
export const VISUALIZER_HEXAGON_STROKE_COLOR = 'rgba(255,255,255,0.9)';
export const VISUALIZER_HEXAGON_SIZE_FACTOR = 0.5;
export const VISUALIZER_HEXAGON_SIZE_FACTOR_XS = 0.1;
export const VISUALIZER_SPEED_MULTIPLIER = 1;
export const VISUALIZER_SPEED_MULTIPLIER_XS = 0.3;
